import React from 'react';
import { FaTimes } from 'react-icons/fa';
import '../styles/InventoryProcurement.css';

function formatDate(raw) {
  if (!raw) return '—';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

function statusLabel(status) {
  const s = String(status || '');
  if (s === 'OnHold' || s === 'On Hold') return 'On Hold';
  return s || '—';
}

function statusClass(status) {
  const s = String(status || '').toLowerCase();
  if (s.includes('hold')) return 'iproc-pill--onhold';
  if (s.includes('inactive')) return 'iproc-pill--inactive';
  return 'iproc-pill--active';
}

export default function SupplierDetailModal({ supplier, onClose, onEdit, onImport }) {
  if (!supplier) return null;
  const products = supplier.productCount ?? 0;
  const lastOrder = formatDate(supplier.lastOrderDate);

  return (
    <div className="iproc-overlay" onClick={onClose}>
      <div className="iproc-modal" onClick={(e) => e.stopPropagation()}>
        <header className="iproc-modal-header">
          <h2>Supplier — {supplier.name}</h2>
          <button type="button" className="iproc-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </header>
        <div className="iproc-modal-body">
          <div className="iproc-badges">
            <span className="iproc-code-badge">{supplier.code}</span>
            <span className={`iproc-pill ${statusClass(supplier.status)}`}>
              {statusLabel(supplier.status)}
            </span>
          </div>

          <div className="iproc-detail-cards">
            <div className="iproc-detail-card">
              <b>Company Name</b>
              <span>{supplier.name}</span>
            </div>
            <div className="iproc-detail-card">
              <b>Contact Person</b>
              <span>{supplier.contactPerson || '—'}</span>
            </div>
            <div className="iproc-detail-card">
              <b>Phone</b>
              <span>{supplier.phone || '—'}</span>
            </div>
            <div className="iproc-detail-card">
              <b>Email</b>
              <span>{supplier.email || '—'}</span>
            </div>
            <div className="iproc-detail-card">
              <b>Products Supplied</b>
              <span>{products}</span>
            </div>
            <div className="iproc-detail-card">
              <b>Last Order</b>
              <span>{lastOrder}</span>
            </div>
          </div>

          <div className="iproc-banner">
            <strong>{products} products</strong> are sourced from this supplier.
            Last order was placed on <strong>{lastOrder}</strong>.
          </div>

          <div className="iproc-modal-footer">
            <button type="button" className="iproc-btn" onClick={onClose}>Close</button>
            <button
              type="button"
              className="iproc-btn"
              onClick={() => onImport?.(supplier)}
            >
              Upload Word catalog
            </button>
            <button
              type="button"
              className="iproc-btn iproc-btn--primary"
              onClick={() => onEdit?.(supplier)}
            >
              Edit Supplier
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
